export default "__VITE_ASSET__CLyTaNQ___"